var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Form, Grid, Header, Select } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { buildOnComponentStateChangeHandler } from "../FormState";
import { defaultBufferState, defaultProbeSetState, defaultSampleTypeState, discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { ErrorElements } from "../rna-fish/NewRnaFishKitPage";
import ProbeSetForm from "../rna-fish/ProbeSetForm";
import { LiquidVolume } from "../rna-cish/RnaCatalog";
import { AmplifierForm } from "../rna-cish/AmplifierForm";
import ProBufferForm from "../rna-cish/BufferForm";
import ManualBufferForm from "../rna-fish/BufferForm";
import ChromogenForm from "../rna-cish/ChromogenForm";
import SelectSampleTypeForm from "../rna-fish/SelectSampleTypeForm";
import { defaultRnaCishChromogenState } from "../rna-cish/AdminEditKitForm";
import ManualProAdminKitSerializer from "./ManualProAdminKitSerializer";
var ManualProAdminKitForm = /** @class */ (function (_super) {
    __extends(ManualProAdminKitForm, _super);
    function ManualProAdminKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onAmpStateChange = buildOnComponentStateChangeHandler(ampStateWrangler, _this.props.setFormState);
        _this.onProBufferStateChange = buildOnComponentStateChangeHandler(proBufStateWrangler, _this.props.setFormState);
        _this.onManualBufferStateChange = buildOnComponentStateChangeHandler(manualBufStateWrangler, _this.props.setFormState);
        _this.onChromogenStateChange = buildOnComponentStateChangeHandler(chromogenStateWrangler, _this.props.setFormState);
        _this.onSampleTypeStateChangeBaseHandler = buildOnComponentStateChangeHandler(sampleTypeStateWrangler, _this.props.setFormState);
        _this.onProbeSetEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeSetEnabled: !s.probeSetEnabled };
            }, function (newState) {
                if (newState.probeSetEnabled) {
                    _this.onProbeSetStateChange({}, _this.props.formState.probeSetState.hcrAmplifier, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onAmplifierStateChange = function (updateObjOrFn, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.ampState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                ampState: Object.assign({}, oldState.ampState, stateCalculator(oldState))
            }); }, function (newState) {
                // propagate to chromogen component
                if (newState.ampState.antiHapten2Ap.label == 'NONE' && _this.props.formState.chromogenState.chromogen.enzymeCompatibility === 'AP' ||
                    newState.ampState.antiHapten2Hrp.label == 'NONE' && _this.props.formState.chromogenState.chromogen.enzymeCompatibility === 'HRP') {
                    _this.onChromogenStateChange({
                        chromogen: {
                            id: 'NONE',
                            label: 'NONE',
                            protocolCompatibility: [],
                            enzymeCompatibility: '',
                            bufferCompatibility: {
                                id: 'NONE',
                                label: 'NONE'
                            }
                        },
                        chromogenBuffer: {
                            id: 'NONE',
                            label: 'NONE'
                        },
                        chromogenScaleSlides: 0,
                        chromogenBufferScaleSlides: 0,
                        hematoxylinScaleSlides: 0
                    }, callback);
                }
                else if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onSampleTypeStateChange = function (sampleTypeFormState, prevSampleType, callback) {
            return _this.onSampleTypeStateChangeBaseHandler(sampleTypeFormState, function (newState) {
                var sampleType = newState.sampleTypeFormState.sampleType;
                if (sampleType.id === "NORTHERN_BLOT") {
                    _this.onManualBufferStateChange({
                        goldWash: new LiquidVolume(0)
                    }, callback);
                }
                else if (prevSampleType.id === "NORTHERN_BLOT" && sampleType.id !== prevSampleType.id) {
                    _this.onManualBufferStateChange({
                        goldWash: _this.props.catalog.goldFishBuffer.goldWash.defaultVolumeMl
                    }, callback);
                }
                else {
                    if (callback !== undefined) {
                        callback();
                    }
                }
            });
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        _this.onProbeSetStateChange = function (updateObjOrFn, prevAmplifier, callback) {
            var stateCalculator;
            if (typeof updateObjOrFn === "function") {
                stateCalculator = function (oldState) {
                    // apply the provided function
                    return updateObjOrFn(oldState.probeSetState);
                };
            }
            else {
                stateCalculator = function () {
                    // just return the plain object
                    return updateObjOrFn;
                };
            }
            _this.props.setFormState(function (oldState) { return ({
                probeSetState: Object.assign({}, oldState.probeSetState, stateCalculator(oldState))
            }); }, function (newState) {
                callback ? callback(newState) : {};
            });
        };
        _this.onAmplifierEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { ampEnabled: !s.ampEnabled };
            }, function (newState) {
                if (newState.ampEnabled) {
                    _this.onAmpStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onChromogenEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { chromogenEnabled: !s.chromogenEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onProBuffersEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { proBuffersEnabled: !s.proBuffersEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onManualBuffersEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { manualBuffersEnabled: !s.manualBuffersEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onDetectScaleChange = function (_, data) {
            var scale = _this.props.catalog.cishAmplifier.manualProAmplifierScales.find(function (c) { return c === data.value; }) || data.value;
            var ah2ApScale;
            if (_this.props.formState.ampState.antiHapten2Ap != null && _this.props.formState.ampState.antiHapten2Ap.id !== "NONE") {
                ah2ApScale = scale;
            }
            var ah2HrpScale;
            if (_this.props.formState.ampState.antiHapten2Hrp != null && _this.props.formState.ampState.antiHapten2Hrp.id !== "NONE") {
                ah2HrpScale = scale;
            }
            _this.props.setFormState(function () {
                return {
                    detectScale: scale
                };
            }, function () {
                _this.onAmpStateChange({
                    amplifierScale: scale,
                    antiHapten1Scale: scale,
                    tyramideHaptenScale: scale,
                    antiHapten2ApScale: ah2ApScale,
                    antiHapten2HrpScale: ah2HrpScale
                }, function () {
                    _this.onProBufferStateChange({
                        amplificationBufferScale: scale,
                        blockingSolutionScale: scale,
                        dewaxScale: scale,
                        antigenRetrievalScale: scale,
                        endogenousEnzymeScale: scale,
                        preHybridizationScale: 0,
                        hrpQuencherScale: scale,
                        bluingAgentScale: scale
                    }, function () {
                        _this.onChromogenStateChange({
                            chromogenScaleSlides: _this.props.formState.chromogenState.chromogen.id !== 'NONE' ? scale : 0,
                            chromogenBufferScaleSlides: _this.props.formState.chromogenState.chromogenBuffer.id !== 'NONE' ? scale : 0,
                            hematoxylinScaleSlides: _this.props.formState.chromogenState.chromogenScaleSlides !== 0 ? scale : 0
                        }, function () {
                            _this.onUserSelection();
                        });
                    });
                });
            });
        };
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(ManualProAdminKitForm.serializeManualProAdminKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElements(json.errors); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: undefined
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    ManualProAdminKitForm.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var protocolType = (_a = this.props.catalog.cishProtocols.find(function (c) { return c.id === 'MANUAL'; })) !== null && _a !== void 0 ? _a : (function () { throw new Error("Required Pro platform not found"); })();
        var probePrice;
        var ampPrice;
        var proBufferPrice;
        var chromogenPrice;
        var manualBufferPrice;
        var kitPrice = this.props.formState.price ?
            this.props.formState.price.kitPrice.individualKitPrices.find(function (k) { return k.channel === 1; }) : undefined;
        if (kitPrice !== undefined) {
            probePrice = (_b = kitPrice.probeSetPrices.find(function (p) { return p.index === 1; })) === null || _b === void 0 ? void 0 : _b.priceCents;
            ampPrice = (_c = kitPrice.amplifierPrices.find(function (p) { return p.index === 1; })) === null || _c === void 0 ? void 0 : _c.priceCents;
            chromogenPrice = (_d = kitPrice.chromogenPrices.find(function (p) { return p.index === 1; })) === null || _d === void 0 ? void 0 : _d.priceCents;
            proBufferPrice = (_e = kitPrice.buffersPrices.find(function (p) { return p.index === 2; })) === null || _e === void 0 ? void 0 : _e.priceCents;
            manualBufferPrice = (_f = kitPrice.buffersPrices.find(function (p) { return p.index === 1; })) === null || _f === void 0 ? void 0 : _f.priceCents;
        }
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: '/' }),
            React.createElement("div", null),
            React.createElement(Header, { className: "component-slider" },
                React.createElement("span", { className: 'sample-type-span' }, "Sample type")),
            React.createElement("div", { className: 'no-outline-kit-component' },
                React.createElement(SelectSampleTypeForm, { sampleTypeState: this.props.formState.sampleTypeFormState, sampleTypes: this.props.catalog.goldFishBuffer.sampleTypes, manualPro: true, onSampleTypeChange: this.onSampleTypeStateChange, onUserSelection: this.onUserSelection, showErrors: this.props.showErrors, errors: this.props.formState.errors })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.probeSetEnabled, otherComponentStates: [this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.proBuffersEnabled, this.props.formState.manualBuffersEnabled], onChange: this.onProbeSetEnableChange, label: "HCR™ HiFi Probe", cish: false },
                React.createElement(ProbeSetForm, { catalog: this.props.catalog, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: true, onProbeSetChange: this.onProbeSetStateChange, onUserSelection: this.onUserSelection, priceCents: probePrice, priceLoading: this.props.formState.priceLoading, probeSetState: this.props.formState.probeSetState, selectedSampleType: this.props.formState.sampleTypeFormState.sampleType, restrictCustomTargetProbeSetSizeToCatalog: false, manualPro: true, legacy: false, showErrors: this.props.showErrors })),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Header, null, "Detect scales"),
                    React.createElement(Select, { options: this.props.catalog.cishAmplifier.manualProAmplifierScales.map(function (s) {
                            return {
                                text: s,
                                value: s
                            };
                        }), onChange: this.onDetectScaleChange, value: this.props.formState.detectScale, search: true }))),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.ampEnabled, label: 'AMPLIFIER', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.chromogenEnabled, this.props.formState.proBuffersEnabled, this.props.formState.manualBuffersEnabled], onChange: this.onAmplifierEnableChange, cish: false },
                React.createElement(AmplifierForm, { protocolType: protocolType, lockScales: true, ampState: this.props.formState.ampState, catalog: this.props.catalog.cishAmplifier, errors: this.props.formState.errors, hcrAmplifierDisabled: true, enableCustomPrice: this.props.enableCustomPrice, onAmpStateChange: this.onAmplifierStateChange, onChromogenStateChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: ampPrice, priceLoading: this.props.formState.priceLoading, ampComponent: undefined })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.chromogenEnabled, label: 'CHROMOGEN', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.proBuffersEnabled, this.props.formState.manualBuffersEnabled], onChange: this.onChromogenEnableChange, cish: false },
                React.createElement(ChromogenForm, { protocolType: protocolType, lockScales: true, ampState: this.props.formState.ampState, chromogenState: this.props.formState.chromogenState, nonOtherKit: true, allScales: 50, catalog: this.props.catalog.cishChromogens, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, onChromogenChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: chromogenPrice, priceLoading: this.props.formState.priceLoading, chromogenComponent: undefined })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.proBuffersEnabled, label: 'PRO BUFFERS', otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.manualBuffersEnabled], onChange: this.onProBuffersEnableChange, cish: false },
                React.createElement(ProBufferForm, { protocolType: protocolType, lockScales: true, bufferState: this.props.formState.proBuffersState, catalog: this.props.catalog.cishBuffer, enableCustomPrice: this.props.enableCustomPrice, errors: this.props.formState.errors, onBufferChange: this.onProBufferStateChange, onUserSelection: this.onUserSelection, priceCents: proBufferPrice, priceLoading: this.props.formState.priceLoading, buffComponent: undefined })),
            React.createElement(ToggleableKitComponent, { componentEnabled: this.props.formState.manualBuffersEnabled, otherComponentStates: [this.props.formState.probeSetEnabled, this.props.formState.ampEnabled, this.props.formState.chromogenEnabled, this.props.formState.proBuffersEnabled], onChange: this.onManualBuffersEnableChange, label: "HCR™ Buffers", cish: false },
                React.createElement(ManualBufferForm, { sampleType: this.props.formState.sampleTypeFormState.sampleType, legacy: false, manualPro: true, bufferState: this.props.formState.manualBuffersState, catalog: this.props.catalog.goldFishBuffer, enableCustomPrice: this.props.enableCustomPrice, enableCustomScale: true, errors: this.props.formState.errors, onBufferChange: this.onManualBufferStateChange, onUserSelection: this.onUserSelection, priceCents: manualBufferPrice, priceLoading: this.props.formState.priceLoading, showErrors: this.props.showErrors })),
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: "/" }),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { style: { 'paddingRight': '.5rem' } },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPriceCents)))));
    };
    ;
    ManualProAdminKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    ManualProAdminKitForm.serializeManualProAdminKit = function (formState) {
        var serializer = new ManualProAdminKitSerializer();
        if (formState.probeSetEnabled) {
            serializer.setProbeSetState(formState.probeSetState);
        }
        if (formState.ampEnabled) {
            serializer.setAmplifier(formState.ampState);
        }
        if (formState.proBuffersEnabled) {
            serializer.setProBuffers(formState.proBuffersState);
        }
        if (formState.manualBuffersEnabled) {
            serializer.setManualBuffers(formState.manualBuffersState);
        }
        if (formState.chromogenEnabled) {
            serializer.setChromogen(formState.chromogenState);
        }
        return serializer.serializeKit(formState.comment, formState.sampleTypeFormState.sampleType);
    };
    return ManualProAdminKitForm;
}(React.PureComponent));
export default ManualProAdminKitForm;
export var defaultManualProAmpState = function (e, catalog) { return ({
    enzyme: e,
    hcrAmplifier: e.amplifier,
    hapten: e.hapten,
    antiHapten1: e.antiHapten1,
    tyramideHapten: e.tyramideHapten,
    antiHapten2Ap: e.antiHapten2Ap,
    antiHapten2Hrp: e.antiHapten2Hrp,
    amplifierScale: catalog.manualProDefaultAmplifierScale,
    antiHapten1Scale: catalog.manualProDefaultAmplifierScale,
    tyramideHaptenScale: catalog.manualProDefaultAmplifierScale,
    antiHapten2ApScale: 0,
    antiHapten2HrpScale: catalog.manualProDefaultAmplifierScale,
}); };
export var defaultProBufferState = function (catalog) { return ({
    sampleType: {
        id: "",
        label: ""
    },
    amplificationBufferScale: catalog.cishBuffer.manualProDefaultBufferScale,
    blockingSolutionScale: catalog.cishBuffer.manualProDefaultBufferScale,
    endogenousEnzymeScale: catalog.cishBuffer.manualProDefaultBufferScale,
    preHybridizationScale: 0,
    hrpQuencherScale: catalog.cishBuffer.manualProDefaultBufferScale,
    bluingAgentScale: catalog.cishBuffer.manualProDefaultBufferScale,
    antigenRetrievalScale: 0,
    dewaxScale: 0,
}); };
export var defaultManualProAdminFormState = function (catalog) {
    var _a, _b;
    return {
        ampEnabled: true,
        manualBuffersEnabled: true,
        proBuffersEnabled: true,
        chromogenEnabled: true,
        comment: '',
        errors: [],
        price: undefined,
        priceLoading: false,
        probeSetEnabled: true,
        ampState: defaultManualProAmpState((_b = (_a = catalog.manualProAmpCatalog) === null || _a === void 0 ? void 0 : _a.amplifierConfig.find(function (c) {
            return c.amplifier.id === 'X2' && c.protocolType.id === 'MANUAL' && c.displayName === 'HRP';
        })) !== null && _b !== void 0 ? _b : (function () {
            throw new Error("Required CISH amplifier config not found");
        })(), catalog.cishAmplifier),
        proBuffersState: defaultProBufferState(catalog),
        manualBuffersState: defaultBufferState(catalog, false, true),
        probeSetState: defaultProbeSetState(catalog, false, true),
        chromogenState: defaultRnaCishChromogenState(),
        sampleTypeFormState: defaultSampleTypeState(),
        detectScale: catalog.cishAmplifier.manualProDefaultAmplifierScale
    };
};
var AmpStateWrangler = /** @class */ (function () {
    function AmpStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ ampState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.ampState; };
    }
    return AmpStateWrangler;
}());
var ProBufferStateWrangler = /** @class */ (function () {
    function ProBufferStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ proBuffersState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.proBuffersState; };
    }
    return ProBufferStateWrangler;
}());
var ManualBufferStateWrangler = /** @class */ (function () {
    function ManualBufferStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ manualBuffersState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.manualBuffersState; };
    }
    return ManualBufferStateWrangler;
}());
var ChromogenStateWrangler = /** @class */ (function () {
    function ChromogenStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ chromogenState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.chromogenState; };
    }
    return ChromogenStateWrangler;
}());
var SampleTypeStateWrangler = /** @class */ (function () {
    function SampleTypeStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ sampleTypeFormState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.sampleTypeFormState; };
    }
    return SampleTypeStateWrangler;
}());
var ampStateWrangler = new AmpStateWrangler();
var proBufStateWrangler = new ProBufferStateWrangler();
var manualBufStateWrangler = new ManualBufferStateWrangler();
var chromogenStateWrangler = new ChromogenStateWrangler();
var sampleTypeStateWrangler = new SampleTypeStateWrangler();
//# sourceMappingURL=ManualProAdminKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProAdminKitForm.js
// module id = 115
// module chunks = 0